import DateRangePicker from "@/components/DateRangePicker";
import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { SimpleGrid } from "@chakra-ui/react";
import { useCallback } from "react";
import { mapPayoutBatchStatus } from "../mappers/payouts.mapper";
import type { BatchesFiltersType } from "../types/payouts.type";

interface Props {
  queryFilters: BatchesFiltersType;
  setQueryFilters: React.Dispatch<React.SetStateAction<BatchesFiltersType>>;
}

export default function BatchesFilters({
  queryFilters,
  setQueryFilters,
}: Props) {
  const handleIdChange = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, id: value || undefined })),
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} gap={3} mb={4}>
      <DebouncedInput
        placeholder="Lote ID"
        size="sm"
        value={queryFilters.id}
        onDebouncedChange={handleIdChange}
      />
      <DateRangePicker
        values={queryFilters.dateRange}
        setValues={(range) =>
          setQueryFilters((prev) => ({ ...prev, dateRange: range }))
        }
      />
      <SelectFilter
        isClearable
        options={Object.keys(mapPayoutBatchStatus)}
        selectedOption={queryFilters.status}
        onSelect={(option) =>
          setQueryFilters((prev) => ({ ...prev, status: option }))
        }
        placeholder="Estado"
      />
    </SimpleGrid>
  );
}
